__turbopack_context__.v({
  "baseLink": "styles-module__JMZDmG__baseLink",
  "baseListItem": "styles-module__JMZDmG__baseListItem",
  "firstLevelLink": "styles-module__JMZDmG__firstLevelLink",
  "secondLevelLink": "styles-module__JMZDmG__secondLevelLink",
  "secondLevelList": "styles-module__JMZDmG__secondLevelList",
  "thirdLevelItem": "styles-module__JMZDmG__thirdLevelItem",
  "thirdLevelList": "styles-module__JMZDmG__thirdLevelList",
  "topListItem": "styles-module__JMZDmG__topListItem",
});
